import React from 'react';
import { LifeBuoy } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import './BillingBanner.css';

/**
 * Облако: вход поддержки платформы в склад (админка → «Войти как администратор»).
 * Поддержке — «вы в режиме поддержки, до …» и «Выйти»; администратору склада —
 * «поддержка заходила …, причина» (7 дней). Честно по отношению к клиенту.
 */
function tokenClaims() {
  try {
    const t = localStorage.getItem('wms_token') || '';
    const p = t.split('.')[1];
    return p ? JSON.parse(decodeURIComponent(escape(atob(p.replace(/-/g, '+').replace(/_/g, '/'))))) : null;
  } catch { return null; }
}

const fmt = (v) => new Date(v).toLocaleString('ru-RU', { timeZone: 'Europe/Moscow', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });

export default function SupportBanner() {
  const { plan, logout } = useAuth();
  const c = tokenClaims();
  if (c && c.imp) {
    return (
      <div className="billing-banner billing-banner--warn" role="status">
        <LifeBuoy size={18} aria-hidden="true" />
        <span className="billing-banner__text">Режим поддержки платформы ({c.imp}) — действия записываются в журнал. Вход до {fmt(c.exp * 1000)}.</span>
        <button type="button" className="billing-banner__link" onClick={() => { logout(); window.location.assign('/login'); }}>Выйти</button>
      </div>
    );
  }
  const list = plan?.billing?.support || [];
  if (!list.length) return null;
  const s = list[0];
  return (
    <div className="billing-banner billing-banner--info" role="status">
      <LifeBuoy size={18} aria-hidden="true" />
      <span className="billing-banner__text">Поддержка платформы заходила в склад {fmt(s.at)} ({s.by}): {s.reason}</span>
    </div>
  );
}
